import {useSelector} from 'react-redux'

import {SubBrandCode} from '../../../brand/types'
import {getSubBrandCode} from '../modules/selectors'

/**
 * A helper hook to get the sub-brand code from the store.
 * @returns The sub-brand code
 */
export const useGetSubBrandCode = (): SubBrandCode | undefined => {
  const subBrandCode = useSelector(getSubBrandCode)
  return subBrandCode
}
